import { required, schema } from "@angular/forms/signals";

export interface Collection {
  referenceKey: string;
}

export const initialData: Collection = {
  referenceKey: "",
};

export const collectionSchema = schema<Collection>((rootPath) => {
  required(rootPath.referenceKey, { message: "Reference key is required" });
});
